export default "__VITE_ASSET__CrrjKR2b__"